import { render, staticRenderFns } from "./SelectMailbox.vue?vue&type=template&id=8d22a534"
import script from "./SelectMailbox.vue?vue&type=script&lang=js"
export * from "./SelectMailbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports